export const addDashboardToRecents = (dashboardId: string) =>
	fetch(`/rest/internal/latest/dashboards/history/${dashboardId}`, {
		method: 'POST',
	});
